import React, {Component} from 'react';
import './AdIos.css';
// import firebaseApp from './firebase'
// import {getAnalytics, logEvent, setCurrentScreen} from "firebase/analytics";

// const analytics = getAnalytics(firebaseApp);

let _this;

class AdIos extends Component {
    constructor(props, context) {
        super(props, context);
        _this = this;

    }

    componentDidMount() {
        // setCurrentScreen(analytics, window.location.pathname);
        // logEvent(analytics, 'screen_view')
    }


    render() {
        return <div className="container">
            <br/>
            <a href="https://apps.apple.com/us/app/study-cards-help-to-memorize/id1436913731"
               target="_blank" download style={{textDecoration: 'none', color: '#040404'}}>
                <div className="adTableTop" id="adTableTop">
                    <div id="content">
                        <p>
                            <img src="/study_cards.png" align="left" hspace="5" vspace="5" alt="app icon"
                                 width="54px"/>
                            <p>
                                <b>StudyCards app helps memorize things!</b>
                                <br/>Listen to the Talking Flashcards
                            </p>
                        </p>
                        <p>
                            <b>StudyCards app</b> is a Talking Flashcards. Its user interface
                            mimics the paper sticky notes and cards.
                            The app also can convert text to a natural sounding voice using Apple's embedded
                            text-to-speech
                            engine.
                        </p>
                    </div>
                </div>
            </a>
            <a href="https://apps.apple.com/us/app/airsync-your-stickies/id554182458"
               target="_blank" download style={{textDecoration: 'none', color: '#040404'}}>
                <div className="adTableMiddle" id="adTableMiddle">
                    <div id="content">
                        <p>
                            <img src="/airstickies.png" align="left" hspace="5" vspace="5" alt="app icon"
                                 width="54px"/>
                            <p>
                                <b>AirSync your Stickies</b>
                                <br/>Get the stickies from your Mac
                            </p>
                        </p>
                        <p>
                            <b>AirSync</b> – effortless synchronization for Apple Stickies with your Mac.
                            AirSync synchronizes the regular MacOS's Stickies with iPhone.
                            It's as simple as typing magic number on your Mac.
                        </p>
                    </div>
                </div>
            </a>
            <a href="https://apps.apple.com/us/app/photodj-your-photos-on-tv/id1325400635"
               target="_blank" download style={{textDecoration: 'none', color: '#040404'}}>
                <div className="adTableMiddle" id="adTableMiddle">
                    <div id="content">
                        <p>
                            <img src="/photo_dj.png" align="left" hspace="5" vspace="5" alt="app icon"
                                 width="54px"/>
                            <p>
                                <b>PhotoDj - Your Photos on TV</b>
                                <br/>Display photos on BIGER Screen
                            </p>
                        </p>
                        <p>
                            <b>PhotoDj app</b> - show photos to your friends, family, or TEAM on a BIG Screen of a
                            SmartTV, computer,
                            Tablet, etc.
                            It does not leave any footage on the presentation device or server.

                            With the PhotoDj app, you can zoom in and display the photos or GIF images from your phone's
                            gallery, on Smart TV, PC, Mac, Tablet, another phone, etc. Without any registration.
                        </p>
                    </div>
                </div>
            </a>
            <a href="https://apps.apple.com/us/app/babytube-for-parents-babies/id851093684"
               target="_blank" download style={{textDecoration: 'none', color: '#040404'}}>
                <div className="adTableMiddle" id="adTableMiddle">
                    <div id="content">
                        <p>
                            <img src="/babytube.png" align="left" hspace="5" vspace="5" alt="app icon"
                                 width="54px"/>
                            <p>
                                <b>BabyTube Internet Video player</b>
                                <br/>Made for Parents & Babies
                            </p>
                        </p>
                        <p>
                            <b>With BabyTube</b> , you can relax while your child watches only the content you chose and
                            approved.
                            No Account or registration is needed!
                        </p>
                    </div>
                </div>
            </a>
            <a href="https://apps.apple.com/us/app/baby-watcher-wifi-periscope/id930583309"
               target="_blank" download style={{textDecoration: 'none', color: '#040404'}}>
                <div className="adTableBottom" id="adTableBottom">
                    <div id="content">
                        <p>
                            <img src="/app_baby_watcher.png" align="left" hspace="5" vspace="5" alt="app icon"
                                 width="54px"/>
                            <p>
                                <b>Baby Watcher - WiFi Periscope</b>
                                <br/>Keep an eye on your baby
                            </p>
                        </p>
                        <p>
                            <b>Baby Watcher/WiFi Periscope</b> app lets you use a second phone as a remotely controlled
                            camera.
                            Use a second phone as a remotely controlled camera.
                            Keep an eye on your kids while you're having a coffee break!
                            Also, you can use this app literally as a PERISCOPE!

                            No Account or registration is needed!
                        </p>
                    </div>
                </div>
            </a>
            <br/>
        </div>
    }
}

export default AdIos;